// extracted by mini-css-extract-plugin
export default {"advertDetailParameterList":"c-q_fO","advertDetailParameterList__header":"c-q_fP","advertDetailParameterList__list":"c-q_fQ"};